
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BasketColumn": [
      "DateBasketColumn",
      "DiscountBasketColumn",
      "OrderTypeBasketColumn",
      "PriceBasketColumn",
      "QuantityBasketColumn"
    ],
    "BasketRowsGroupDetailsUnion": [
      "BasketAddressRowsGroupDetails",
      "BasketDeliveryRowsGroupDetails"
    ],
    "FilterValueUnion": [
      "FilterValue",
      "RangeFilterValue"
    ],
    "ITotalProductItem": [
      "BasketLineThumbnail",
      "TotalProductItem"
    ]
  }
};
      export default result;
    